import { useMutation } from "@apollo/client"
import { useCallback } from "react"
import { gql } from "../gql"
import { RoleKeywordScoreType } from "@oysterhr/schema"

const OYSTER_INTELLIGENCE_CREATE_JOB_ROLE_SEARCH = gql(`
  mutation OysterIntelligenceCreateJobRoleSearch($input: CreateJobRoleSearchInput!) {
    createJobRoleSearch(input: $input) {
      errors
    }
  }
`)

export const useCreateJobSearchAnalytics = () => {
  const [runAnalytics] = useMutation(OYSTER_INTELLIGENCE_CREATE_JOB_ROLE_SEARCH, {
    errorPolicy: "none",
  })

  const jobRoleSelectAnalytics = useCallback(
    (searchTerm: string, selectedJobId: string, keywordScore: RoleKeywordScoreType | null) => {
      runAnalytics({
        variables: {
          input: { searchInput: searchTerm, roleTypeId: selectedJobId, keywordScore },
        },
      })
    },
    [runAnalytics],
  )

  return {
    jobRoleSelectAnalytics,
  }
}
